/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { BigNumberDependencies } from './dependenciesBigNumberClass.generated';
import { createLOG10E } from '../../factoriesAny.js';
export var LOG10EDependencies = {
  BigNumberDependencies: BigNumberDependencies,
  createLOG10E: createLOG10E
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesLOG10E.generated.js
// module id = 1438
// module chunks = 0